import env from './environment';

const whitelistedSizes = [64, 96, 140, 200, 225, 300, 400, 500, 640, 960, 1200, 1600];

export function buildImageUrlByZoomId(zoomId, originalSize, format) {
    const PRODUCTION_DOMAIN = 'i.ebayimg.com';
    const STAGING_DOMAIN = 'i.qa.ebayimg.com';
    const PATH_SEPARATOR = '/';
    const size = whitelistedSizes.find(wlSize => wlSize >= originalSize);
    const domain = (env.isProd() || env.isPreProd()) ? PRODUCTION_DOMAIN : STAGING_DOMAIN;
    return `https://${domain}/thumbs/images/g/${zoomId}${PATH_SEPARATOR}s-l${size}.${format}`;
}
